import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, FileSpreadsheet, Users2, Loader2, Cake } from "lucide-react";
import { tplPath } from "@/lib/forms";
import { toast } from "sonner";
import { api, errMsg, fmtDay } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/StatusBadge";

export default function FormsHome() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/forms/templates").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  return (
    <div>
      <PageHeader eyebrow="Main Secretariat" title="Forms & Data" testid="forms-title">
        <Button asChild data-testid="forms-new-button"><Link to="/forms/new"><Plus className="w-4 h-4 mr-1" />New form template</Link></Button>
      </PageHeader>
      <p className="text-sm text-slate-600 mb-5 max-w-2xl">Upload a paper or digital form and AI turns it into an editable template. Each template has its own data page where filled-in forms live as rows.</p>
      {!items ? <div className="p-10 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="forms-list">
          {items.map((t, i) => (
            <Link key={t.template_id} to={tplPath(t)} data-testid={`form-card-${t.template_id}`}
              className="rounded-lg border border-slate-200 bg-white shadow-sm p-5 hover:-translate-y-0.5 transition-transform duration-200 fade-up" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="flex items-start gap-3">
                <span className="w-10 h-10 rounded-md grid place-items-center icon-3d shrink-0" style={{ "--c1": t.kind === "census" ? "#D4AF37" : t.kind === "birthdays" ? "#F472B6" : "#3B82F6", "--c2": t.kind === "census" ? "#7A5A0E" : t.kind === "birthdays" ? "#9D174D" : "#1E3A8A" }}>
                  {t.kind === "census" ? <Users2 className="w-5 h-5 text-white" /> : t.kind === "birthdays" ? <Cake className="w-5 h-5 text-white" /> : <FileSpreadsheet className="w-5 h-5 text-white" />}
                </span>
                <div className="min-w-0">
                  <div className="font-semibold text-slate-900 truncate">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.fields.length} fields · {t.row_count} entries</div>
                </div>
              </div>
              {t.description && <p className="mt-3 text-sm text-slate-600 line-clamp-2">{t.description}</p>}
              <div className="mt-3 text-[11px] text-slate-400">Updated {fmtDay(t.updated_at)}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
